import { get } from '@webapps/utils';

const { NX_REST_API } = process.env;

export const getAllAccounts = {
  query: ({ page, size }) =>
    get({
      url: `${NX_REST_API}/accounts?page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getAllAccountsWithFiltre = {
  query: ({ keyword, page, size, type }) =>
    get({
      url: `${NX_REST_API}/accounts?page=${page}&size=${size}`,
      options: {
        params: {
          ...(type ? { type } : {}),
          ...(keyword ? { keyword } : {}),
        },
      },
    }),
  format: ({ data }) => data,
};
